import { createContext } from "react";
import { INIT_DASHBOARD_CONTEXT } from "./constants";

const DashboardContext = createContext(INIT_DASHBOARD_CONTEXT);

export default DashboardContext;